import { BASIC_COLOURS, BASIC_NO_SWITCH_COLOURS, EXTRA_BRAND_COLOURS, OPAQUE_COLOURS, STATUS_COLOURS } from '../../fundamentals/colours/variants';

export const LINK_VARIANTS = {
  /**
   * @deprecated EORA V2 use linkPrimary or linkAccent instead (defaults to linkPrimary)
   */
  LINK: 'link',
  LINK_PRIMARY: 'linkPrimary',
  LINK_ACCENT: 'linkAccent',
  LINK_WHITE: 'linkWhite',
  LINK_DARK: 'linkDark'
} as const;

export type LinkVariant = (typeof LINK_VARIANTS)[keyof typeof LINK_VARIANTS];

export const BUTTON_VARIANTS = {
  /**
   * @deprecated EORA V2 use accent instead (defaults to accent',)
   */
  HERO: 'hero', // 'accent'
  ACCENT: 'accent',
  PRIMARY: EXTRA_BRAND_COLOURS.PRIMARY,
  SECONDARY: EXTRA_BRAND_COLOURS.SECONDARY,
  SECONDARY_INVERTED: EXTRA_BRAND_COLOURS.SECONDARY_INVERTED,
  ...BASIC_COLOURS,
  ...BASIC_NO_SWITCH_COLOURS,
  ...OPAQUE_COLOURS,
  ERROR: STATUS_COLOURS.ERROR,
  SUCCESS: STATUS_COLOURS.SUCCESS,
  WARNING: STATUS_COLOURS.WARNING,
  ...LINK_VARIANTS
} as const;

export const CLOSE_BUTTON_VARIANTS = {
  WHITE50: 'white50',
  BLACK50: 'black50',
  WHITE50_NO_SWITCH: 'white50NoSwitch',
  BLACK50_NO_SWITCH: 'black50NoSwitch',
  BRAND_AWARE: 'brandAware'
} as const;

export type ButtonVariant = (typeof BUTTON_VARIANTS)[keyof typeof BUTTON_VARIANTS] | (typeof CLOSE_BUTTON_VARIANTS)[keyof typeof CLOSE_BUTTON_VARIANTS];

export const BUTTON_MODES = {
  BOLD: 'bold',
  OUTLINE: 'outline',
  MINIMAL: 'minimal'
} as const;

export type ButtonMode = (typeof BUTTON_MODES)[keyof typeof BUTTON_MODES];

export type AllButtonTypes = ButtonVariant;
